import { SIDEBAR_COLLAPSE, SIDEBAR_STATE, SET_DASHBOARD_FILTER } from 'constants/ActionTypes';

export function ConfigReducer(draft, action) {
  const { type, payload } = action;
  switch (type) {
    case SIDEBAR_COLLAPSE:
      draft.statusCollapse = !draft.statusCollapse;
      localStorage.setItem('sideBar', draft.statusCollapse);
      return;
    case SIDEBAR_STATE:
      draft.hasSidebar = payload;
      return;
    case SET_DASHBOARD_FILTER:
      draft.dashboardFilter = payload;
      return;
    default:
      return draft;
  }
}
